import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'send-bills-dialog-sending',
    templateUrl: './dialog-sending.component.html',
    styleUrls: ['./dialog-sending.component.scss']
})
export class SendBillsDialogSendingComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
